$(document).ready(function () {

    $("#item-autor-search").on('input', function() {
        console.log("xD")
    })






        $('.chosen').chosen({
        minimumInputLength: 3,
        ajax: {
            url: '/admin/author/search',
            dataType: 'json',
            delay: 250,
            data: function (params) {
                console.log(params)
                return {
                    q: params.term
                };
            },
            processResults: function (data) {
                console.log(data)
                return {
                    results: $.map(data, function (item) {
                        return {
                            id: item.id,
                            text: item.nombre
                        }
                    })
                };
            },
            cache: true
        }
    })
})
